import { METADATA_API_HOSTNAME } from "../../../config/envConfig";
import magnifiAPIInstance from "./apiInstance";

export const metaDataAPIs = {
  getMetaTags: (data) => {
    return magnifiAPIInstance.post(`${METADATA_API_HOSTNAME}/clip-metadata/tags`, data);
  },
  metaTagsDetails: (data) => {
    return magnifiAPIInstance.put(`${METADATA_API_HOSTNAME}/clip-metadata/tags/selected`, data);
  },
};
